import FrontEnd from './Components/Common/FrontEnd';
import './style.scss'

import { createRoot } from 'react-dom/client';

document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.wp-block-b3dviewer-modelviewer')
    blocks.forEach(block => {
        const attributes = JSON.parse(block.dataset.attributes)

        const id = block.id;
        createRoot(block).render(<FrontEnd attributes={attributes} id={id} />);

        block.removeAttribute('data-attributes');

    })
})